import type { JSX } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from '@heroicons/react/24/outline';

import { formatFrameworkTitle, TEST_LAYER_LABELS } from '../utils';

interface FrameworkBreadcrumbProps {
  frameworkId: string;
  testLayer: string;
}

export function FrameworkBreadcrumb({
  frameworkId,
  testLayer,
}: FrameworkBreadcrumbProps): JSX.Element {
  return (
    <nav className="flex items-center gap-1 text-sm text-muted mb-4" aria-label="Breadcrumb">
      <Link to="/patterns/frameworks" className="hover:text-foreground transition-colors">
        Frameworks
      </Link>
      <ChevronRightIcon className="h-3 w-3" />
      <span className="text-muted">{TEST_LAYER_LABELS[testLayer] ?? testLayer}</span>
      <ChevronRightIcon className="h-3 w-3" />
      <span className="text-foreground font-medium">{formatFrameworkTitle(frameworkId)}</span>
    </nav>
  );
}
